// extracted by mini-css-extract-plugin
export default {"textoGanador":"textoGanador_textoGanador__33aq+"};